import React, { useState } from 'react';
import {  Switch, Tooltip, Radio, Modal, Input, Checkbox } from "antd";
import running from "../../../assets/img/running.svg";


const CustomSwitchButtons = ({
    defaultState,
    handleQuickUpdate,
    title,
    item,
  }) => {
    const handleButtonClick = () => {
      handleQuickUpdate(
        item.id,
        item.athlete,
        title,
        Number(defaultState) === 1 ? 0 : 1
      );
    };
  
    return (
       <div className="turn-over actor flex w-[100%] items-center justify-center">
        {Number(defaultState) ? (
         
            <Switch
              disabled={item.disabled}
              checked={true}
              onChange={() => handleButtonClick()}
            />
         
        ) : (
          <Switch
              disabled={item.disabled}
              checked={false}
              onChange={() => handleButtonClick()}
            />
          
        )}
        </div>
      
    );
  };


  export default CustomSwitchButtons;


 export const SackRadioButtons = ({
  defaultState,
  handleQuickUpdate,
  title,
  item,
  tooltipTitle,
  tooltipTitleTwo,
}) => {
  const handleButtonClick = (value) => {
    handleQuickUpdate(item.id, item.athlete, title, value);
  };

  return (
    <div className="discipline actor flex w-[100%] items-center justify-center ">
      <Radio.Group
        disabled={item.disabled}
        defaultValue={defaultState}
        onChange={({ target: { value: e } }) => {
          handleButtonClick(e);
        }}
      >
        <Tooltip title={tooltipTitle}>
          <Radio.Button
            value={0}
            className={
              defaultState === 0 ? "onefive-active" : "onefive-inacive"
            }
          >
            TFL
          </Radio.Button>
        </Tooltip>
        <Tooltip title={tooltipTitleTwo}>
          <Radio.Button
            value={2}
            className={
              defaultState === 2 ? "onefive-active" : "onefive-inacive"
            }
          >
            <img src={running} />
          </Radio.Button>
        </Tooltip>
        <Radio.Button
          value={1}
          className={defaultState === 1 ? "one-active" : "one-inacive"}
        >
          sack
        </Radio.Button>
      </Radio.Group>
    </div>
  );
};

export const TackleRadioButtons = ({
  defaultState,
  handleQuickUpdate,
  title,
  text,
  item,
  img,
  tooltipTitle,
  tooltipTitleThree,
  tooltipTitleTwo,
  imageTwo,
  imageThree,
  imageFour,
  value,
  color,
  colorThree,
  textTwo,
  textThree,
}) => {
  const handleButtonClick = (value) => {
    handleQuickUpdate(
      item.id,
      item.athlete,
      title,
      value,
      true,
      item.punt_distance || true
    );
  };
  return (
    <div className="discipline actor flex w-[100%] items-center justify-center ">
      <Radio.Group
        disabled={item.disabled}
        defaultValue={defaultState}
        onChange={({ target: { value: e } }) => {
          console.log("click on change", e);
        }}
        mode="tags"
      >
        <Tooltip title={tooltipTitle}>
          <Radio.Button
            value={0}
            onClick={() => {
              handleButtonClick(0);
            }}
            className={defaultState === 0 ? "x-active" : "x-inacive"}
          >
            {img ? <img src={img} /> : "x"}
          </Radio.Button>
        </Tooltip>
        <Tooltip title={tooltipTitleTwo}>
          {color ? (
            <Radio.Button
              onClick={() => {
                handleButtonClick(2);
              }}
              value={2}
              className={defaultState === 2 ? color : "onefive-inacive"}
            >
              {imageTwo && <img src={imageTwo} />}
              {textTwo && <span>{textTwo}</span>}
              {!imageTwo && !textTwo && "0.5"}
            </Radio.Button>
          ) : (
            <Radio.Button
              value={3}
              className={
                defaultState === 3 ? "onefive-active" : "onefive-inacive"
              }
              onClick={() => {
                handleButtonClick(3);
              }}
            >
              {imageTwo && <img src={imageTwo} />}
              {textTwo && <span>{textTwo}</span>}
              {!imageTwo && !textTwo && "0.5"}
            </Radio.Button>
          )}
        </Tooltip>
        {value ? (
          <Tooltip title={tooltipTitleThree}>
            <Radio.Button
              value={4}
              onClick={() => {
                handleButtonClick(4);
              }}
              className={
                defaultState === 4
                  ? colorThree
                    ? colorThree
                    : "one-active"
                  : "one-inacive"
              }
            >
              {imageThree ? <img src={imageThree} /> : value}
            </Radio.Button>
          </Tooltip>
        ) : (
          <Tooltip title={tooltipTitleThree}>
            <Radio.Button
              value={1}
              onClick={() => {
                handleButtonClick(1);
              }}
              className={defaultState === 1 ? "one-active" : "one-inacive"}
            >
              {imageThree && <img src={imageThree} />}
              {textThree && <span>{textThree}</span>}
              {!imageThree && !textThree && "1.0"}
            </Radio.Button>
          </Tooltip>
        )}
      </Radio.Group>
    </div>
  );
};

export const FlagSwitchButtons = ({
  defaultState,
  handleQuickUpdate,
  title,
  item,
}) => {
  const handleButtonClick = () => {
    handleQuickUpdate(
      item.id,
      item.athlete,
      title,
      Number(defaultState) === 1 ? 0 : 1
    );
  };

  return (
    <>
      {Number(defaultState) ? (
        <div className="flagged actor flex items-center w-[100%] justify-center">
          <Switch
            disabled={item.disabled}
            checked={true}
            onChange={() => handleButtonClick()}
          />
        </div>
      ) : (
        <div className="flagged actor flex w-[100%] items-center justify-center">
          <Switch
            disabled={item.disabled}
            checked={false}
            onChange={() => handleButtonClick()}
          />
        </div>
      )}
    </>
  );
};

export const EffortsSwitchButtons = ({
  defaultState,
  handleQuickUpdate,
  title,
  item,
}) => {
  const handleButtonClick = () => {
    handleQuickUpdate(
      item.id,
      item.athlete,
      title,
      Number(defaultState) === 1 ? 0 : 1
    );
  };

  return (
    <>
      {Number(defaultState) ? (
        <div
          id="execution"
          className="actor w-[100%] flex items-center justify-center"
        >
          <Switch
            disabled={item.disabled}
            checked={true}
            onChange={() => handleButtonClick()}
          />
        </div>
      ) : (
        <div id="execution" className="actor">
          <Switch
            disabled={item.disabled}
            checked={false}
            onChange={() => handleButtonClick()}
          />
        </div>
      )}
    </>
  );
};

export const CarryRadioButtons = ({
  defaultState,
  handleQuickUpdate,
  title,
  tooltipTitle,
  item,
  img,
  color,
}) => {
  const handleButtonClick = (value) => {
    handleQuickUpdate(
      item.id,
      item.athlete,
      title,
      value,
      true,
      item.punt_distance || true
    );
  };
  return (
    <div className="discipline actor flex w-[100%] items-center justify-center ">
      <Radio.Group
        disabled={item.disabled}
        defaultValue={defaultState}
        onChange={({ target: { value: e } }) => {
          handleButtonClick(e);
        }}
        mode="tags"
      >
        <Tooltip title={tooltipTitle}>
          {color ? (
            <Radio.Button
              value={0}
              className={defaultState === 0 ? color : "x-inacive"}
            >
              {img ? <img src={img} /> : "x"}
            </Radio.Button>
          ) : (
            <Radio.Button
              value={2}
              className={defaultState === 2 ? "x-active" : "x-inacive"}
            >
              {img ? <img src={img} /> : "x"}
            </Radio.Button>
          )}
        </Tooltip>
        <Radio.Button
          value={1}
          className={defaultState === 1 ? "onefive-active" : "onefive-inacive"}
        >
          1
        </Radio.Button>
      </Radio.Group>
    </div>
  );
};

export const PuntDistance = ({
  item,
  handleQuickUpdate,
  setDistanceModal,
  distanceModal,
  defaultState,
}) => {
  const [distance, setDistance] = useState(defaultState);
  const [inside, setInside] = useState(item.punt_inside_20);
  const [fair, setFair] = useState(item.punt_fair_catch);
  const updateGrade = (path, value) => {
    handleQuickUpdate(item.id, item.athlete, path, value);
  };
  return (
    <>
      <Modal
        open={distanceModal}
        width={634}
        footer={null}
        closable={false}
        onCancel={() => {
          setDistanceModal(false);
        }}
        title={
          <div className="flex font-inter text-[14px] text-[#0F1A24] items-center">
            <span className=" font-bold">{distanceModal?.title}</span>
            <div className="w-[1px] h-[30px] bg-[#A9B6C2] mx-2"></div>
            <span className="font-[400]">
              {item?.first_name} {item?.last_name}
            </span>
          </div>
        }
      >
        <div className="flex flex-col w-full mt-4">
          <div
            style={{ border: "1px solid #F3F5F7)" }}
            className="w-full flex flex-col text-sm font-bold text-[#20364B]"
          >
            <div className="w-full flex">
              <div
                style={{ border: "1px solid #F3F5F7)" }}
                className="w-[25%] flex items-center p-3 justify-center bg-[#F3F5F7]"
              >
                <span>{distanceModal?.title}</span>
              </div>
              <div
                style={{ border: "1px solid #F3F5F7)" }}
                className="w-[20%] flex items-center p-3 justify-center turn-over actor"
              >
                <Input
                  defaultValue={distanceModal.default}
                  onChange={({ target: { value } }) => setDistance(value)}
                  className="w-[70%]"
                  size="large"
                />
              </div>
              {distanceModal?.hasOptions ? (
                <>
                  {" "}
                  <div
                    style={{ border: "1px solid #F3F5F7)" }}
                    className="w-[25%] flex items-center p-3 justify-center"
                  >
                    <Checkbox
                      defaultChecked={item.punt_inside_20}
                      onChange={({ target: { checked: e } }) =>
                        setInside(e ? 1 : 0)
                      }
                    >
                      <span className="text-[#2E4D6B]">Inside 20</span>
                    </Checkbox>
                  </div>
                  <div
                    style={{ border: "1px solid #F3F5F7)" }}
                    className="w-[25%] flex items-center p-3 justify-center"
                  >
                    <Checkbox
                      defaultChecked={item.punt_fair_catch}
                      onChange={({ target: { checked: e } }) =>
                        setFair(e ? 1 : 0)
                      }
                    >
                      <span className="text-[#2E4D6B]">Fair Catch</span>
                    </Checkbox>
                  </div>{" "}
                </>
              ) : (
                ""
              )}
            </div>
          </div>
          <div className="flex items-center justify-between text-md mt-4  w-full flex-col">
            <button
              onClick={() => {
                handleQuickUpdate(
                  item.id,
                  item.athlete,
                  distanceModal.path,
                  distance
                );
                distanceModal?.hasOptions &&
                  handleQuickUpdate(
                    item.id,
                    item.athlete,
                    "punt_inside_20",
                    inside
                  );
                distanceModal?.hasOptions &&
                  handleQuickUpdate(
                    item.id,
                    item.athlete,
                    "punt_fair_catch",
                    fair
                  );
                setDistanceModal(false);
              }}
              className="flex items-center focus:outline-0 self-end justify-center w-[30%] bg-[#1A91FF] text-[#ffffff] h-11 rounded-[4px]"
            >
              <span className="ml-2">Save</span>
            </button>
          </div>
        </div>
      </Modal>
    </>
  );
};